module.exports = __webpack_public_path__ + "static/img/6en.2519dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/6en.png
// module id = 5T7K
// module chunks = 0